import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { MappedContextProvider } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { useSliderContext } from "@/components/BannerSlider/components/slider/context/slider.context";
import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { speed, slides, setMainSwiper, setActiveIndex, stopTimer } =
        useBannerSliderContext();

    const { navigationNextRef, navigationPrevRef } = useSliderContext();

    const { slider_slides_wrapper, slider_slides_swiperslide } = bannerSlider();

    return (
        <Swiper
            modules={[Navigation]}
            onSwiper={setMainSwiper}
            updateOnWindowResize={true}
            onRealIndexChange={(swiper) => {
                setActiveIndex(swiper.realIndex);
            }}
            onSliderMove={stopTimer}
            resizeObserver={true}
            slidesPerView={1}
            slidesPerGroup={1}
            rewind={true}
            className={cn(className)}
            wrapperClass={slider_slides_wrapper()}
            navigation={{
                nextEl: navigationNextRef.current,
                prevEl: navigationPrevRef.current
            }}
            loop={true}
            speed={speed}
        >
            {slides.map((_, index) => (
                <SwiperSlide
                    key={index}
                    className={slider_slides_swiperslide()}
                >
                    <MappedContextProvider index={index}>
                        {children}
                    </MappedContextProvider>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};
